// extracted by mini-css-extract-plugin
export default {"name":"actionLink_name__mLFC3","link":"actionLink_link__2U-3G"};